import React from 'react';
import { useInView } from 'react-intersection-observer';
export const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <section id="about" className="py-20 bg-white" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-44">
            About Ukweli Institute
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6" data-id="element-45"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-46">
            An independent, science-driven laboratory redefining credibility in
            the $120B wellness and supplement industry.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-47">
          <div className="space-y-6" data-id="element-48">
            <p className="text-gray-700" data-id="element-49">
              Ukweli Institute bridges the gap between biohacker discovery,
              consumer wellness, and pharma-level science by testing
              supplements, probiotics, and microbiome-targeted therapies with
              the rigor of pharmaceutical research.
            </p>
            <p className="text-gray-700" data-id="element-50">
              Our mission is to provide transparent, evidence-based evaluations
              of wellness products, empowering consumers, clinicians, and
              policymakers to make informed decisions based on scientific merit
              rather than marketing claims.
            </p>
            <p className="text-gray-700" data-id="element-51">
              Through our rigorous testing methodologies and independent
              research initiatives, we're establishing new standards for
              credibility in an industry often criticized for insufficient
              scientific validation.
            </p>
          </div>
          <div data-id="element-52">
            <img src="https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80" alt="Scientific research at Ukweli Institute" className="rounded-lg shadow-xl w-full h-auto" data-id="element-53" />
          </div>
        </div>
      </div>
    </section>;
};